<template>
<div>
  <div class="aviso2" v-if="env && env.mode && env.mode != 'production'">
    Ambiente de Teste
  </div>
  <b-navbar class="header1" toggleable="lg" type="dark" variant="light" align="center" fixed="top">
    <b-navbar-brand href="#" :title="':: '+usuario.logged.point.nome+'\n:: '+usuario.logged.nome">
      <img :src="cliente.logged.url_logo" alt="Kitten" width="120">
      <div class="align-content-center flex-wrap" style="font-size:7pt">
        <span v-if="sub_domain == 'empresa'">Area da Empresa</span>
        <span v-if="sub_domain == 'credenciada'">Area da Credenciada</span>
        <span v-if="sub_domain == 'parceiro'">Area do Parceiro</span>
      </div>
    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse" type="dark"></b-navbar-toggle>
    
    <b-collapse id="nav-collapse" is-nav class="">

      <el-menu class="el-menu-demo" mode="horizontal" background-color="transparent" text-color="#fff" unique-opened active-text-color="#fff" >
        <template v-for="(menu,i) in usuario.menu">
          <!---MENU-->
          <el-menu-item 
            v-if="menu.sub_menu.length==0" 
            :index="i.toString()" 
            :class="menu.class+(menu.rota == $route.path ? ' is-active' : '')" 
            :default-active="+(menu.rota == $route.path ? menu.rota : '')"
            @click="toRoute({path: menu.rota})"
            v-bind:key="i"
            exact
          >
            <i :class="menu.icon"/>
            {{menu.descricao}} 
            <b-badge pill variant="danger" v-if="menu.badge && menu.badge>0">{{menu.badge}}</b-badge>
          </el-menu-item>

          <!---SUB MENU-->
          <el-submenu :index="i.toString()" v-else :class="menu.class" v-bind:key="i">
            <template slot="title">
              <i :class="menu.icon"/>
               {{menu.descricao}}
            </template>
            <el-menu-item 
              :index="i.toString()+'-'+j.toString()" 
              v-for="(sub_menu,j) in menu.sub_menu" class="sub_menu" 
              v-bind:key="i+j" 
              @click="toRoute({path:sub_menu.rota})"
            >
              <i :class="sub_menu.icon"/>
              {{sub_menu.descricao}}
            </el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </b-collapse>
  </b-navbar>
</div>
</template>
<script>
import Rest from "common/rest";
import Fct from "common/fct";
import Broadcast from "common/broadcast";

export default {
  mixins: [Rest,Fct, Broadcast],
  components: { },
  created() {
  },

  mounted: function() {

  },

  data: function() {
    return {
      sessao: "08h 00m",
      loadingContent: true,
        items: [
          {
            text: 'Admin',
            href: '#'
          },
          {
            text: 'Manage',
            href: '#'
          },
          {
            text: 'Library',
            active: true
          }
        ]
    };
  },

  methods: {
    
    getMensagem: function(result) {
      if (result && result.data) {
        var mensagem = result.data;

        this.$notify({
          title: mensagem.title ? mensagem.title : "Atenção",
          message: mensagem.message,
          type: mensagem.type ? mensagem.type : "success",
          offset: 100,
          duration: 10000
        });
      }
    },
  }
};
</script>

<style lang="scss">
  .header1{
    padding:0px !important;
    background:var(--primary) !important;
    color:#fff !important;
  }

  .header1 a img{
    background: #fff !important;
    border-radius: 4px;
    margin: 8px;
  }

  .el-menu-item i{
    color:#fff !important;
  }

  .el-menu-demo{
    border-bottom: none !important;
     width: 100%;
  }

  .el-menu-demo li:hover{
    background: rgba(0, 0, 0, 0.1) !important;
    cursor: pointer;
  }

  .el-menu-demo li:hover{
    background: rgba(0, 0, 0, 0.1) !important;
  }

  .el-menu>.el-menu-item:hover, .el-submenu__title:hover{
    background: rgba(0, 0, 0, 0.1) !important;
    cursor: pointer;
  }

  .el-submenu__title i{
    color:#fff !important;
  }

  .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{
    color:#fff !important;
  }

  .el-menu--horizontal .el-menu--popup-bottom-start{
    background: #fff !important
  }
  
  .float-right{
    float: right !important;
    color:#fff !important;
  }

  .sub_menu, .sub_menu i{
    color:#666 !important
  }

  .navbar-dark, .navbar-toggler{
    background: #3777a2;
    border: solid 1px #ccc !important;
  }

  .is-active{
    border-bottom-color: rgb(255, 255, 255) !important;
  }

  
</style>



// WEBPACK FOOTER //
// header.v2.vue?4caf13e4